import MedicalHealthInformation from './components/MedicalHealthInformation';
import {
  MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_DOCUMENT_REFERENCE_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME,
  MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME,
  MEDICAL_HEALTH_INFORMATION_DETAIL_NAME,
  MEDICAL_HEALTH_INFORMATION_ERROR_NAME,
  MEDICAL_HEALTH_INFORMATION_NAME
} from './constants/constants';
import MedicalHealthInformationDetail from './components/MedicalHealthInformationDetail';
import MedicalHealthInformationError from './components/MedicalHealthInformationError';
import MedicalHealthInformationBranch from './components/MedicalHealthInformationBranch';
import MedicalHealthInformationBranchQuestionnaireResponse from './components/MedicalHealthInformationBranchQuestionnaireResponse';
import MedicalHealthInformationBranchObservation from './components/MedicalHealthInformationBranchObservation';
import MedicalHealthInformationBranchCondition from './components/MedicalHealthInformationBranchCondition';
import MedicalHealthInformationBranchDocumentReference from './components/MedicalHealthInformationBranchDocumentReference';
import MedicalHealthInformationBranchMediaImage from './components/MedicalHealthInformationBranchMediaImage';
import MedicalHealthInformationBranchMediaVideo from './components/MedicalHealthInformationBranchMediaVideo';

export type ViewKey =
  | typeof MEDICAL_HEALTH_INFORMATION_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_DOCUMENT_REFERENCE_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_IMAGE_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_MEDIA_VIDEO_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_DETAIL_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_ERROR_NAME;

export type DetailViewKey =
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_QUESTIONNAIRE_RESPONSE_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_OBSERVATION_NAME
  | typeof MEDICAL_HEALTH_INFORMATION_BRANCH_CONDITION_NAME;

const getViews = () => {
  return {
    MedicalHealthInformation: () => {
      return <MedicalHealthInformation />;
    },
    MedicalHealthInformationBranch: () => {
      return <MedicalHealthInformationBranch />;
    },
    MedicalHealthInformationBranchQuestionnaireResponse: () => {
      return <MedicalHealthInformationBranchQuestionnaireResponse />;
    },
    MedicalHealthInformationBranchObservation: () => {
      return <MedicalHealthInformationBranchObservation />;
    },
    MedicalHealthInformationBranchCondition: () => {
      return <MedicalHealthInformationBranchCondition />;
    },
    MedicalHealthInformationBranchDocumentReference: () => {
      return <MedicalHealthInformationBranchDocumentReference />;
    },
    MedicalHealthInformationBranchMediaImage: () => {
      return <MedicalHealthInformationBranchMediaImage />;
    },
    MedicalHealthInformationBranchMediaVideo: () => {
      return <MedicalHealthInformationBranchMediaVideo />;
    },
    MedicalHealthInformationDetail: () => {
      return <MedicalHealthInformationDetail />;
    },
    MedicalHealthInformationError: () => {
      return <MedicalHealthInformationError />;
    }
  } as const;
};

export const GetRenderView = (targetViewKey: ViewKey) => {
  const views = getViews();
  return views[targetViewKey]();
};
export default GetRenderView;
